export const homeStyle = {
    home: 'flex bg-gray-50 md:flex-row flex-col h-screen transaction-height duration-75 ease-out',
    sideBar: 'hidden md:flex h-screen flex-initial',
    sideBarContainer: 'fixed w-4/5 bg-white h-screen overflow-y-auto shadow-md z-10 animate-slide-in',
    sideBarContent: 'absolute w-full flex justify-end items-center p-2',
    menu: 'p-2 w-full flex flex-row justify-between items-center shadow-md',
    routeContainer: 'pb-2 flex-1 h-screen overflow-y-scroll',
    hiMenuContainer: 'flex md:hidden flex-row',
    hiMenu: 'cursor-pointer',
    homeLogo: 'w-28'
}
